<script>
import { merchantComputed, authComputed } from "@store/helpers";
import formatServiceTime from "@utils/format-service-time";
import formatCurrency from "@utils/format-currency";
import { memberLevelPriceDiscount } from "@utils/ipetbooking-level";

export default {
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    priceList: {
      type: Array,
      default: () => {
        return [
          {
            title: '迷你 (3kg以下)',
            alias: 'alias1',
            price: 900,
            serviceTime: 90,
            priceIsFlexible: 0,
            images: [
              {
                default: 1,
                path: 'https://assets.codepen.io/1759070/service-1%402x.png'
              }
            ]
          },
        ]
      }
    },
    storeAlias: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activeService: '',
    }
  },
  computed: {
    ...merchantComputed,
    ...authComputed,
    activePrice: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value);
      }
    },
  },
  methods: {
    formatServiceTime,
    formatCurrency,
    memberLevelPriceDiscount,
    getDefaultImage(images) {
      const defaultImageItems = images.filter(image => image.default) || [];

      return defaultImageItems[0]?.path || ''
    },
  },
}
</script>
<!-- section template -->
<template>
  <div :class="[$style.priceCollapse,{
    [$style['isStyleDingBeautyForPriceCollapse']]: $globalIsDingBeauty,
  }]">
    <el-collapse
      v-if="priceList.length > 1"
      v-model="activePrice"
      :class="$style.priceList"
      accordion
    >
      <el-collapse-item
        v-for="(priceItem, index) in priceList"
        :key="`priceItem-${index}`"
        class="priceList__item"
        :name="index"
      >
        <template slot="title">
          <div class="d-flex align-items-center justify-content-between w-100 priceList__header">
            <span class="priceList__name">
              {{ priceItem.title }}
            </span>
            <span class="text-right">
              <div class="priceList__price">
                <template v-if="priceItem.levelDiscount > 0">
                  <span class="fs-base">會員價: NT$ {{ formatCurrency( memberLevelPriceDiscount(priceItem.price, priceItem)) }} </span>
                  <span v-if="!!priceItem.priceIsFlexible" className="fs-sm">起</span>
                  <br>
                  <del :class="$globalIsDingBeauty ? 'text-white' : 'text-gray-2'">
                    原價：NT$ {{ formatCurrency(priceItem.price) }}
                    <span v-if="!!priceItem.priceIsFlexible" className="fs-sm">起</span>
                  </del>
                </template>
                <template v-else >
                  NT$ {{ formatCurrency(priceItem.price) }} 
                  <span v-if="!!priceItem.priceIsFlexible" className="fs-sm">起</span>
                </template>
              </div>
              <div class="priceList__time">
                <i v-if="$globalIsDingBeauty" class="fontello fontello-time"></i> {{ formatServiceTime(priceItem.serviceTime) }}
              </div>
              
            </span>
          </div>
        </template>
        <div>
          <div class="d-flex mb-2">
            <div
              v-if="!!priceItem.images && !!priceItem.images[0]"
              class="priceList__imageBox"
            >
              <div
                class="priceList__image"
                :style="{ backgroundImage: `url('${ getDefaultImage(priceItem.images) }')` }"
              >

              </div>
            </div>
            <div
              class="priceList__description"
              v-html="priceItem.description"
            ></div>
          </div>
          <BaseButton
            v-if="isSiteEnabled"
            class="isStylePrimary isTextUnderline2"
            :to="{ name: 'reservation-item', params: { storeAlias, reservationAlias: priceItem.alias }, query: { section: 'date' } }"
          >
            前往預約
          </BaseButton>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div
      v-else
      :class="$style.priceList"
    >
      <div
        v-for="(priceItem, index) in priceList"
        :key="`priceItem-${index}`"
        class="priceList__item"
        :name="index"
      >
        <div class="d-flex align-items-center justify-content-between w-100 priceList__header">
          <span class="priceList__name">
            <!-- {{ priceItem.title }} -->
          </span>
          <span class="text-right">
            <div class="priceList__price">
              <template v-if="priceItem.levelDiscount > 0">
                <span class="fs-base">會員價: NT$ {{ formatCurrency( memberLevelPriceDiscount(priceItem.price, priceItem)) }} </span>
                <span v-if="!!priceItem.priceIsFlexible" className="fs-sm">起</span>
                <br>
                <del :class="$globalIsDingBeauty ? 'text-white' : 'text-gray-2'">
                  原價：NT$ {{ formatCurrency(priceItem.price) }}
                  <span v-if="!!priceItem.priceIsFlexible" className="fs-sm">起</span>
                </del>
              </template>
              <template v-else >
                NT$ {{ formatCurrency(priceItem.price) }} 
                <span v-if="!!priceItem.priceIsFlexible" className="fs-sm">起</span>
              </template>
            </div>
            <div class="priceList__time">
              <i v-if="$globalIsDingBeauty" class="fontello fontello-time"></i> {{ formatServiceTime(priceItem.serviceTime) }}
            </div>
            
          </span>
        </div>
        <div>
          <div class="d-flex mb-2">
            <div
              v-if="!!priceItem.images && !!priceItem.images[0]"
              class="priceList__imageBox"
            >
              <div
                class="priceList__image"
                :style="{ backgroundImage: `url('${ getDefaultImage(priceItem.images) }')` }"
              >

              </div>
            </div>
            <div
              class="priceList__description"
              v-html="priceItem.description"
            ></div>
          </div>
          <BaseButton
            v-if="isSiteEnabled"
            :class="{ 'isStyleWhite isTextUnderline': $globalIsDingBeauty,
            'isStylePrimary isTextUnderline2': !$globalIsDingBeauty }"
            :to="{ name: 'reservation-item', params: { storeAlias, reservationAlias: priceItem.alias }, query: { section: 'date' } }"
          >
            前往預約
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.priceCollapse {
  :global {
    .priceCollapse {
      @include unstyled;
    }
  }
  &.isStyleDingBeautyForPriceCollapse {
    :global {
      .isTextUnderline2::before{
        background-color: white;
        bottom: -5px;
      }
      .priceList {
        &__item {
          &:not(:last-child) {
            border-bottom: 1px solid $color-line;
          }
        }
        &__link {
          color: #fff;
          opacity: 1;
          &:hover {
            opacity: 0.8;
          }
        }

        &__description {
          color: #fff;
        }
      }
    }
  }
}

.priceList {
  @include list-unstyled;

  min-height: 425px;
  border-top: unset;
  border-bottom: unset;

  @include max-lg {
    min-height: 0;
  }

  :global {
    .priceList {
      &__item {
        &:not(:last-child) {
          border-bottom: 1px solid $color-line;
        }
      }
      &__header {
        padding-top: 0.7rem;
        padding-bottom: 0.7rem;
      }
      &__name {
        font-size: 0.875rem;
      }

      &__price {
        font-family: $font-number;
        font-weight: 400;
        line-height: 1.5;
        color: $color-gray-1;
      }

      &__time {
        font-size: 0.75rem;
        line-height: 1.5;
        color: $color-gray-2;
      }

      &__link {
        color: $color-gray-1;

        &:hover {
          color: $color-primary;
        }
      }

      &__description {
        // margin-bottom: 0.5rem;
        color: $color-gray-2;
      }

      &__imageBox {
        flex-shrink: 0;
        width: 185px;
        margin-right: 1rem;
      }

      &__image {
        padding-top: 73%;
        background-color: $color-bg-default;
        background-position: center;
        background-size: cover;
      }
    }

    // 11:00 12:00 14:00 17:30

    // stylelint-disable selector-class-pattern
    .el-collapse-item__header {
      flex-direction: row-reverse;
      height: auto;
      // line-height: 70px;
      border-bottom: unset;

      &:hover, &.is-active {
        color: $color-primary;
      }

    }

    .el-collapse-item__wrap {
      border-bottom: unset;
    }

    .el-collapse-item__content {
      padding-bottom: 1.25rem;
      padding-left: 1.5rem;
    }

    .el-collapse-item__arrow {
      transform: translateY(-2px) rotate(-90deg) !important;

      &::before {
        font-family: $font-fontello;
        font-size: 0.75rem;
        color: $color-gray-3;
        content: $fontello-down;
      }

      &.is-active {
        transform: translateY(-2px) rotate(0deg) !important;
      }
    }

    // stylelint-enable selector-class-pattern
  }
}
</style>
